var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-button-wrapper"},[_c('p',{staticClass:"tiny-text"},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('span',{staticClass:"highlight"},[_vm._v(" "+_vm._s(_vm.balance)+" "+_vm._s(_vm.currency.toUpperCase()))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }